import React, { createContext, useState, useContext } from 'react';

// Criar o contexto
const CategoryContext = createContext();

// Componente provedor
export const CategoryProvider = ({ children }) => {
  const [category, setCategory] = useState(null); // Categoria selecionada
  const [brand, setBrand] = useState(null);       // Marca selecionada

  return (
    <CategoryContext.Provider value={{ category, setCategory, brand, setBrand }}>
      {children}
    </CategoryContext.Provider>
  );
};

// Hook customizado
export const useCategory = () => useContext(CategoryContext);
